import {useProductSearchStore} from "./store";
import {useSearch} from "./useSearch";
import {FilterFieldTypeEnum} from "./filter-types";
import {filterBuilders, FilterPayloadMap} from "../libs/builder/filterBuilders";

export type OnChangeFilterHandler = <K extends FilterFieldTypeEnum>(
    valueField: string | boolean | number | number[],
    keyField: string,
    typeField: K
) => void;
export const useFilterHandler = () => {
    const {filter, search,} = useProductSearchStore();
    const {fetchingSearch} = useSearch();
    /**
     *  Универсальный обработчик для всех типов фильтров
     * “Формирует новое состояние фильтра по ключу и типу, вызывает поиск с этим состоянием”.
     */
    const onChangeFilter: OnChangeFilterHandler = (valueField, keyField, typeField) => {
        const builder = filterBuilders[typeField];
        const payload = {key: keyField, value: valueField} as FilterPayloadMap[typeof typeField];
        const result = builder(filter?.state ?? {}, payload);
        fetchingSearch({searchTerm: search.token, startIndex: 0, filterState: result});

    }
    /**
     *Метод для сброса состояния фильтрации и строки поиска
     * “Вызывает поиск без фильтров и без поискового слова (обнуляет search.token)”.
     */
    const onResetFilter = () => {
        fetchingSearch({searchTerm: "", startIndex: 0});
    }

    return {
        onResetFilter,
        onChangeFilter,
    }
}